(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yd-home-snowfall"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if(!document.getElementById('yd-home-snowfall-config')||window.__ydHomeSnowfall?.version==='2.2')return;
  const TAU = Math.PI * 2;
  const presets = { light: { density: .35, wind: .7 }, medium: { density: .64, wind: .85 }, heavy: { density: 1, wind: 1 } };
  const insets = {
    desktop: [[.0415,.581,.1925,.369,.019],[.246,.581,.1915,.369,.019],[.453,.581,.1925,.369,.019]],
    mobile: [[.057,.611,.883,.17,.039],[.055,.795,.433,.168,.036],[.513,.795,.431,.168,.036]]
  };
  const building = {
    desktop: [[.478,0],[1,0],[1,.90],[.655,.98],[.626,.76],[.359,.566],[.386,.481],[.411,.422],[.410,.325],[.397,.336],[.430,.14],[.445,.128],[.468,.177],[.48,.185],[.468,.095]],
    mobile: [[.548,.178],[.693,.255],[1,.240],[1,.66],[.71,.70],[.285,.645],[.281,.489],[.236,.48],[.321,.441],[.346,.429],[.349,.362],[.383,.337],[.411,.365],[.434,.37],[.457,.408],[.447,.328]]
  };
  function seeded(seed) {
    return () => {seed|=0;seed=seed+0x6D2B79F5|0;let t=Math.imul(seed^seed>>>15,1|seed);t^=t+Math.imul(t^t>>>7,61|t);return((t^t>>>14)>>>0)/4294967296;};
  }
  const mod=(v,n)=>((v%n)+n)%n;
  const smooth=(a,b,n)=>{const x=Math.max(0,Math.min(1,(n-a)/(b-a)));return x*x*(3-2*x);};
  function makeFlake(variant, depth, warm) {
    const rand=seeded(4271+variant*197);
    const canvas=document.createElement('canvas');canvas.width=canvas.height=64;
    const c=canvas.getContext('2d');
    const color=warm?'255,248,234':depth===0?'230,240,253':'245,249,255';
    const points=7+Math.floor(rand()*5);
    const sx=.68+rand()*.4,sy=.78+rand()*.42;
    c.save();c.translate(32,32);c.scale(sx,sy);
    c.filter=`blur(${depth===2?4.5:depth===1?1.8:2.6}px)`;
    c.fillStyle=`rgba(${color},${depth===2?.76:.94})`;
    c.beginPath();
    for(let j=0;j<points;j++){
      const angle=j*TAU/points;
      const radius=10+rand()*9;
      const x=Math.cos(angle)*radius,y=Math.sin(angle)*radius;
      if(j===0)c.moveTo(x,y);else c.lineTo(x,y);
    }
    c.closePath();c.fill();
    for(let j=0;j<3;j++){
      const a=rand()*TAU,d=rand()*10;
      c.beginPath();c.ellipse(Math.cos(a)*d,Math.sin(a)*d,3+rand()*5,2+rand()*4,a,0,TAU);c.fill();
    }
    c.restore();return canvas;
  }

  class YeloDeerSnow {
    constructor(host,options={}) {
      this.host=host;this.options=options;this.mode=options.mode||'desktop';this.level=options.level||'heavy';
      this.paused=false;this.inView=true;this.active=true;this.time=0;this.frames=0;this.frame=0;this.last=0;
      this.version='2.0';
      this.canvas=document.createElement('canvas');this.canvas.className='yd-snow-canvas';this.canvas.setAttribute('aria-hidden','true');
      Object.assign(this.canvas.style,{position:'absolute',inset:'0',width:'100%',height:'100%',pointerEvents:'none',zIndex:'2'});
      this.ctx=this.canvas.getContext('2d',{alpha:true});
      if(!this.ctx)return;
      host.appendChild(this.canvas);
      this.sprites=Array.from({length:3},(_,layer)=>Array.from({length:12},(_,i)=>[makeFlake(i,layer,false),makeFlake(i,layer,true)]));
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.onVisibility=()=>this.sync();this.onMotion=()=>{this.sync();this.draw();};
      document.addEventListener('visibilitychange',this.onVisibility);this.motion.addEventListener('change',this.onMotion);
      this.resizeObserver=new ResizeObserver(()=>this.resize());this.resizeObserver.observe(host);
      this.intersectionObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.sync();},{threshold:.01});this.intersectionObserver.observe(host);
      this.tick=stamp=>{
        this.frame=0;if(!this.canRun())return;
        if(!this.last)this.last=stamp;
        const elapsed=stamp-this.last;
        const interval=1000/(this.mobile?30:60);
        if(elapsed>=interval-1){
          this.time+=Math.min(elapsed/1000,.06);this.last=stamp;this.frames++;this.draw();
        }
        this.frame=requestAnimationFrame(this.tick);
      };
      this.resize();
    }
    resize() {
      const hostStyle=getComputedStyle(this.host);
      const box={width:parseFloat(hostStyle.width)||this.host.clientWidth,height:parseFloat(hostStyle.height)||this.host.clientHeight};
      this.width=box.width;this.height=box.height;
      const image=this.options.imageResolver?.();
      const imageStyle=image?getComputedStyle(image):null;
      if(!box.width||!box.height)return;
      this.dpr=Math.min(devicePixelRatio||1,1.5);
      this.canvas.width=Math.round(box.width*this.dpr);this.canvas.height=Math.round(box.height*this.dpr);
      this.mobile=image?/\/newbanner-1m\.jpg$/i.test(new URL(image.currentSrc||image.src,location.href).pathname):this.mode==='mobile'||this.mode==='auto'&&matchMedia('(max-width:767px)').matches;
      this.sceneW=this.mobile?750:1440;this.sceneH=this.mobile?1400:600;
      this.scale=(imageStyle?.objectFit==='contain'?Math.min:Math.max)(this.width/this.sceneW,this.height/this.sceneH);
      const position=(imageStyle?.objectPosition||'50% 50%').split(' ');
      const offset=(free,value)=>value?.endsWith('%')?free*parseFloat(value)/100:parseFloat(value)||free/2;
      this.offsetX=offset(this.width-this.sceneW*this.scale,position[0]);this.offsetY=offset(this.height-this.sceneH*this.scale,position[1]);
      const random=seeded(this.mobile?70936:96253);
      const total=this.mobile?1100:1380;
      this.layers=[[],[],[]];
      for(let i=0;i<total;i++){
        const d=random(),layer=d<.48?0:d<.965?1:2;
        const z=layer===0?.10+random()*.22:layer===1?.40+random()*.4:.84+random()*.16;
        const flake={
          x:random(),y:random(),layer,z,variant:i%12,rank:random(),
          phase:random()*TAU,phase2:random()*TAU,phase3:random()*TAU,
          frequency:.5+random()*.72,rotation:random()*TAU,
          fall:(24+z*115)*(0.65+random()*.6)*(this.mobile?1.22:1),
          radius:(layer===0?.45+random()*.7:layer===1?1.15+Math.pow(random(),1.7)*2.2:2.9+random()*3.2)*(this.mobile?1.22:1),
          alpha:layer===0?.27+random()*.3:layer===1?.61+random()*.33:.33+random()*.2,
          drift:-3+random()*6,sway:1.5+random()*7,flutter:random(),
        };
        this.layers[layer].push(flake);
      }
      this.particles=this.layers.flat();
      this.draw();this.sync();
    }
    canRun(){return this.ctx&&this.width>0&&this.inView&&this.active&&!this.paused&&this.level!=='off'&&!document.hidden&&(!this.motion.matches||this.options.allowMotion);}
    sync(){if(!this.canRun()){cancelAnimationFrame(this.frame);this.frame=0;this.last=0;return;}if(!this.frame){this.last=0;this.frame=requestAnimationFrame(this.tick);}}
    setLevel(level){this.level=presets[level]||level==='off'?level:'heavy';this.draw();this.sync();}
    setMode(mode){this.mode=mode;this.resize();}
    setPaused(paused){this.paused=paused;this.sync();}
    setActive(active){this.active=active;this.sync();}
    drawLayer(layer,t,setting) {
      const c=this.ctx;
      const gust=(17*t+24/.24*(Math.sin(t*.24-.8)-Math.sin(-.8))+8/.63*(Math.sin(t*.63+1.6)-Math.sin(1.6)))*setting.wind;
      const wind=(17+24*Math.cos(t*.24-.8)+8*Math.cos(t*.63+1.6))*setting.wind;
      const logo=this.mobile?[112,210,635,418]:[42,49,370,200];
      for(const p of this.layers[layer]){
        if(p.rank>setting.density)continue;
        const phase=t*p.frequency+p.phase;
        const bob=Math.sin(t*.61+p.phase2)*p.sway*.35;
        const y=mod(p.y*(this.sceneH+80)+t*p.fall+bob,this.sceneH+80)-40;
        const x=mod(p.x*(this.sceneW+140)+(gust+p.drift*t)*(.24+p.z*.85)+Math.sin(phase)*p.sway+Math.sin(t*1.81+p.phase2)*p.sway*.22,this.sceneW+140)-70;
        const distance=Math.max(logo[0]-x,x-logo[2],logo[1]-y,y-logo[3]);
        const logoFade=.20+.80*smooth(-20,52,distance);
        const edgeFade=Math.min(smooth(-30,10,y),1-smooth(this.sceneH-8,this.sceneH+32,y));
        const tumble=.83+.12*Math.sin(phase*.89+p.phase2)+.05*Math.sin(phase*1.77+p.phase3);
        const patch=.90+.10*Math.sin(x*.007+y*.004-t*.25+p.z*2);
        const alpha=p.alpha*logoFade*edgeFade*tumble*patch;
        if(alpha<.008)continue;
        const vx=wind*(.24+p.z*.85)+p.drift+p.sway*p.frequency*Math.cos(phase);
        const vy=p.fall+p.sway*.21*Math.cos(t*.61+p.phase2);
        const exposure=layer===0?.011:layer===1?.030:.024;
        const trail=Math.hypot(vx,vy)*exposure;
        const rotation=Math.atan2(vy,vx)-Math.PI/2;
        const nearLight=this.mobile?x>340&&y>630&&y<900:x>920&&y>270&&y<540;
        const sprite=this.sprites[layer][p.variant][nearLight&&p.variant%3===0?1:0];
        const size=p.radius*3.4;
        const stretch=1+trail/(size*1.8);
        const width=size*(.86+.14*Math.sin(phase+p.phase3));
        c.globalAlpha=alpha;
        if(layer===0){
          c.drawImage(sprite,x-width/2,y-size*stretch/2,width,size*stretch);
        }else{
          c.save();c.translate(x,y);c.rotate(rotation+.13*Math.sin(phase+p.phase2));
          c.drawImage(sprite,-width/2,-size*stretch/2,width,size*stretch);c.restore();
        }
      }
    }
    draw() {
      const c=this.ctx;if(!c||!this.width)return;
      c.setTransform(1,0,0,1,0,0);c.clearRect(0,0,this.canvas.width,this.canvas.height);
      if(this.level==='off'||this.motion.matches&&!this.options.allowMotion)return;
      const setting=presets[this.level];
      c.setTransform(this.dpr*this.scale,0,0,this.dpr*this.scale,this.dpr*this.offsetX,this.dpr*this.offsetY);
      c.save();c.beginPath();c.rect(0,0,this.sceneW,this.sceneH);c.clip();
      this.drawLayer(0,this.time,setting);
      c.globalAlpha=1;c.globalCompositeOperation='destination-out';c.fillStyle='#000';
      c.beginPath();building[this.mobile?'mobile':'desktop'].forEach(([x,y],i)=>{if(i===0)c.moveTo(x*this.sceneW,y*this.sceneH);else c.lineTo(x*this.sceneW,y*this.sceneH);});c.closePath();c.fill();
      c.globalCompositeOperation='source-over';
      this.drawLayer(1,this.time,setting);this.drawLayer(2,this.time,setting);
      c.globalAlpha=1;c.globalCompositeOperation='destination-out';c.fillStyle='#000';c.beginPath();
      for(const[x,y,w,h,r]of insets[this.mobile?'mobile':'desktop'])c.roundRect(x*this.sceneW,y*this.sceneH,w*this.sceneW,h*this.sceneH,r*this.sceneW);
      c.fill();c.restore();c.globalAlpha=1;
    }
    destroy(){cancelAnimationFrame(this.frame);this.resizeObserver.disconnect();this.intersectionObserver.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.motion.removeEventListener('change',this.onMotion);this.canvas.remove();}
  }
  const controllers=new Map();
  let scanFrame=0;
  function imageFor(slide) {
    return [...slide.querySelectorAll('img')].find(image=>
      /\/newbanner-1m?\.jpg$/i.test(new URL(image.currentSrc||image.src,location.href).pathname)&&getComputedStyle(image).display!=='none'
    );
  }
  function reconcile() {
    scanFrame=0;
    for(const[slide,controller]of controllers)if(!slide.isConnected){controller.destroy();controllers.delete(slide);}
    const slideshow=document.querySelector('main sht-slideshow');
    if(!slideshow)return;
    for(const wrapper of slideshow.querySelectorAll('.js-slideshow-image[data-slideshow-index="1"]')){
      const slide=wrapper.closest('.js-slideshow-item');
      if(!slide||controllers.has(slide)||!imageFor(slide))continue;
      const host=wrapper.querySelector('.media-wrapper');
      if(!host)continue;
      const previousPosition=host.style.position;
      if(getComputedStyle(host).position==='static')host.style.position='relative';
      const snow=new YeloDeerSnow(host,{mode:'auto',level:'heavy',allowMotion:true,imageResolver:()=>imageFor(slide)});
      if(!snow.ctx){host.style.position=previousPosition;continue;}
      const pauseButton=slideshow.querySelector('.js-slideshow-start-n-stop-btn');
      const update=()=>{
        const image=imageFor(slide);
        snow.setActive(Boolean(image)&&slide.getAttribute('aria-hidden')!=='true');
        snow.setPaused(slideshow.autoplay===false);
        if(!image)snow.ctx.clearRect(0,0,snow.canvas.width,snow.canvas.height);
      };
      const onPlay=()=>queueMicrotask(()=>{
        if(slideshow.autoplay===true)snow.options.allowMotion=true;
        snow.draw();update();
      });
      const resize=()=>{snow.resize();update();};
      const observer=new MutationObserver(update);
      observer.observe(slide,{attributes:true,attributeFilter:['aria-hidden','class']});
      if(pauseButton)observer.observe(pauseButton,{attributes:true,attributeFilter:['aria-label']});
      const images=[...slide.querySelectorAll('img')];
      for(const image of images){image.addEventListener('load',resize);observer.observe(image,{attributes:true,attributeFilter:['src','srcset']});}
      pauseButton?.addEventListener('click',onPlay);
      const controller={snow,slideshow,slide,destroy(){observer.disconnect();pauseButton?.removeEventListener('click',onPlay);for(const image of images)image.removeEventListener('load',resize);snow.destroy();host.style.position=previousPosition;}};
      controllers.set(slide,controller);
      update();
    }
  }
  function schedule(){if(!scanFrame)scanFrame=requestAnimationFrame(reconcile);}
  const observer=new MutationObserver(schedule);
  const main=document.querySelector('main');
  if(main)observer.observe(main,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
  window.__ydHomeSnowfall={version:'2.2',controllers,status(){return [...controllers.values()].map(({snow,slide})=>({level:snow.level,mobile:snow.mobile,active:snow.active,paused:snow.paused,frames:snow.frames,running:Boolean(snow.canRun()),reducedMotion:snow.motion.matches,width:snow.width,height:snow.height,scale:snow.scale,offsetX:snow.offsetX,offsetY:snow.offsetY,slide:slide.getAttribute('aria-label')}));},destroy(){observer.disconnect();document.removeEventListener('shopify:section:load',schedule);document.removeEventListener('shopify:section:unload',schedule);cancelAnimationFrame(scanFrame);for(const controller of controllers.values())controller.destroy();controllers.clear();delete window.__ydHomeSnowfall;}};
  if(customElements.get('sht-slideshow'))reconcile();
  else customElements.whenDefined('sht-slideshow').then(reconcile);

})();
  } catch(e) { console.error(e); }
})();

})();
